export default {
    styleOverrides: {
        root: {
            borderRadius: 6
        }
    }
}
